import React, { useEffect } from "react";
import { MatchParams } from "../types";
import { RouteComponentProps } from "react-router-dom";
import Item from "./EmailItem";
import { Helmet } from "react-helmet";
import useArchiveValue from "../../hooks/useArchiveValue";
import useArchiveEmail from "../../hooks/useArchiveEmail";
import { linkify } from "../../lib/utils";
import useLists from "../../hooks/useLists";

function ArchivesPage(props: RouteComponentProps<MatchParams>) {
  const { listId } = props.match.params;
  // const { getSubscriptionsInfoData, subscriptionsInfo  } = useSubscriptions()
  const { archiveValue, getArchiveValues } = useArchiveValue();
  const { archiveEmail, getArchiveEmails } = useArchiveEmail();
  const { getListsInfoData, listsInfo } = useLists();
  const { archiveSetting, formSettings } = archiveValue;

  useEffect(() => {
    getArchiveEmails(listId);
    getArchiveValues(listId);
    getListsInfoData(listId);
  }, []);

  return (
    <>
      {archiveEmail === null ? (
        <div className="msg">
          <p>삭제된 페이지입니다.</p>
        </div>
      ) : (
        <>
          <Helmet>
            <title>
              {archiveSetting.formTitle
                ? archiveSetting.formTitle
                : listsInfo.data.listName}
            </title>
            <meta
              property="og:title"
              content={
                archiveSetting.formTitle
                  ? archiveSetting.formTitle
                  : listsInfo.data.listName
              }
            />
            <meta
              property="og:image"
              content={archiveSetting && archiveSetting.formHeaderImage}
            />
          </Helmet>
          <div className="frame-archives">
            <div className="inner">
              <div id="stb_archives">
                {archiveSetting && archiveSetting.formHeaderImageShow && (
                  <div className="stb_archives_header">
                    <img
                      src={archiveSetting.formHeaderImage}
                      alt="header_image"
                    ></img>
                  </div>
                )}

                {archiveSetting && archiveSetting.formTitleShow ? (
                  <div className="stb_archives_title">
                    {archiveSetting.formTitle
                      ? archiveSetting.formTitle
                      : listsInfo.data.listName}
                  </div>
                ) : (
                  <>
                    {!archiveSetting && (
                      <div className="stb_archives_title">
                        {listsInfo.data.listName}
                      </div>
                    )}
                  </>
                )}

                {archiveSetting && archiveSetting.formDescriptionShow && (
                  <div className="stb_archives_description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: linkify(archiveSetting.formDescription)
                      }}
                    />
                  </div>
                )}

                <div className="stb_archives_body">
                  <div className="stb_archives_emails">
                    {archiveEmail.length !== 0 &&
                      archiveEmail.map(email => (
                        <Item
                          key={email.id}
                          date={email.sentTime}
                          subject={email.subject}
                          href={email.permanentLink}
                        />
                      ))}

                    {/* <Item date={'2020. 10. 6.'} subject={'✍ 보낸사람: 이슬아, 매일 보낸 이메일로 기회를 만들다.'} href={'https://stib.ee/tfd2'}/> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ArchivesPage;
